import { useState, useCallback, useEffect } from "react";
import DataTable from '../DataTable/DataTable';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import jobReports from "../../apis/requisitionReports/jobReport";
import jsonConfig from "../../Config.json"
import { DateTime } from "luxon";
import "./requisitionReports.css";
import config from "../../Config.json";
import {
  NotificationManager,
} from "react-notifications";
const stylesSX = {
  odd: {
    background: '#F6F6F6 !important',
  },
  even: {
    background: '#ffffff !important', // fixed typo: #fffff ➝ #ffffff
  },
  backdrop: (theme) => ({
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  }),
  waitingText: {
    marginLeft: '5px',
  },
};
const JobReport = (props) => {
  const {
    userType,
    userIdType,
    userRecruitmentpartnerId,
    triggerAction,
    resetTrigger,
    startSelectedDate,
    endSelectedDate,
    additionalFilterData
  } = props;

  const [takeNumberOfResult, setTakeNumberOfResult] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalResult, setTotalResult] = useState(0);
  const [isExporting, setIsExporting] = useState(false);
  const [isSearching, setIsSearching] = useState(true);
  // Track previous date and filter values to detect changes
  const [prevStartDate, setPrevStartDate] = useState(null);
  const [prevEndDate, setPrevEndDate] = useState(null);
  const [prevFilterData, setPrevFilterData] = useState({});

  // Define columns for the new table
  const columns = [
    {
      accessorKey: "placementType",
      header: "Placement Type",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
    },
    {
      accessorKey: "primarySkill",
      header: "Primary Skill",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
    },
    {
      accessorKey: "clientJobId",
      header: "Client Id",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
    },
    {
      accessorKey: "clientDetails.clientName",
      header: "Client Name",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
    },
    {
      accessorKey: "reqreferenceId",
      header: "Reference ID",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
    },
    {
      accessorKey: "statusName",
      header: "Requisition Status",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
    },
    {
      accessorKey: "status.subCode",
      header: "Sub Status",
      width: "180px",
      enableSorting: false,
      enableFiltering: false,
      cell: ({ row }) => {
        const { statusName, status } = row.original;
        if (statusName === "OPEN") {
          const subCode = status?.subCode;
          const subStatusName = Object.entries(jsonConfig.requisitionStatusCodes.OPENSUBSTATUS)
            .find(([key, value]) => value === subCode)?.[0] || "-";
          return subStatusName;
        }
        return "-";
      },
    },
    {
      accessorKey: "country",
      header: "Country",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
    },
    {
      accessorKey: "state",
      header: "State",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
    },
    {
      accessorKey: "city",
      header: "City",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
    },
    {
      accessorKey: "priority",
      header: "Priority",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
    },
    {
      accessorKey: "recruitmentLeaderData",
      header: "Recruitment Leader",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
    },
    {
      accessorKey: "teamLeaderNames",
      header: "Team Leader",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
    },
    {
      accessorKey: "recruiterNames",
      header: "Primary Recruiter",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
    },
    {
      accessorKey: "openings",
      header: "Openings",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
    },
    {
      accessorKey: "open_positions",
      header: "Open Openings",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
    },
    {
      accessorKey: "submit_counts",
      header: "Candidate Submitted",
      width: "180px",
      enableSorting: true,
      enableFiltering: false,
      cell: ({ getValue }) => getValue() ?? 0,
    },
    {
      accessorKey: "start_counts",
      header: "Candidate Started",
      width: "180px",
      enableSorting: true,
      enableFiltering: false,
      cell: ({ getValue }) => getValue() ?? 0,
    },
    {
      accessorKey: "created_at",
      header: "Created On",
      width: "180px",
      enableSorting: true,
      enableFiltering: false,
      cell: ({ getValue }) => {
        const rawDate = getValue();
        if (!rawDate) return "N/A";

        const datePart = rawDate.split("T")[0];
        const date = new Date(datePart);
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const year = date.getFullYear();

        return `${month}/${day}/${year}`;
      },
    }
  ];

  const [dataResult, setDataResult] = useState([]);

  const formatDateOnly = useCallback((dateString) => {
    const date = new Date(dateString);

    // Extract the year, month, and day in the local timezone
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }, []);

  const callApiToGenerateExcel = useCallback(async () => {
    setIsExporting(true);

    const maxSize = config.MAX_SIZE
    const end = Math.ceil(totalResult / maxSize);
    let pageStart = 1;
    let exportArr = [];

    try {
      for (let start = 0; start < end; start++) {
        let payload = {
          userRecruitmentpartnerId,
          isExport: true,
          page: pageStart,
          size: maxSize,
          formattedDatestart: formatDateOnly(startSelectedDate),
          formattedDateend: formatDateOnly(endSelectedDate),
          userId: userIdType,
          role: userType,
          additionalFilter: {
            placementType: additionalFilterData.placementType,
            clientName: additionalFilterData.clientName,
            divisionId: additionalFilterData.divisionId,
            requisitionStatus: additionalFilterData.requisitionStatus,
            requisionSubStatus: additionalFilterData.requisionSubStatus,
            clientJobId: additionalFilterData.clientJobId,
            teamId: additionalFilterData.teamId || []
          }
        };

        const allDetails = await jobReports(payload);
        allDetails.data.forEach((element) => {
          let subStatusName = "-";

          if (element.statusName === "OPEN") {
            const subCode = element.status?.subCode;
            subStatusName =
              Object.entries(jsonConfig.requisitionStatusCodes.OPENSUBSTATUS)
                .find(([key, value]) => value === subCode)?.[0] || "-";
          }

          let data = {
            "Placement Type": element.placementType,
            "Primary Skill": element.primarySkill,
            "Client Name": element.clientDetails?.clientName || "N/A",
            "Client ID": element.clientJobId || "N/A",
            "Reference ID": element.reqreferenceId,
            "Requisition Status": element.statusName || "N/A",
            "Country": element.countryStr,
            "State": element.stateStr,
            "City": element.cityStr,
            "Sub Status": subStatusName,
            "Candidate Started": element.start_counts ?? 0,
            "Candidate Submitted": element.submit_counts ?? 0,
            Priority: element.priority,
            "Recruitment Leader": element.recruitmentLeaderData,
            "Primary Recruiter": element.recruiterNames,
            "Team Leader": element.teamLeaderNames,
            "Created On": DateTime.fromISO(element.created_at)
              .toFormat("MM/dd/yyyy")
              .toString(),
            "Openings": element.openings,
            "Open Openings": element.open_positions
          };
          exportArr.push(data);
        });
        pageStart = pageStart + maxSize;
      }

      if (exportArr.length === 0) {
        NotificationManager.error("No data present", "Error", 10000);
      } else {

        // Lazy load XLSX only when needed for export
       const { utils, writeFile } = await import("xlsx");
        const wb = utils.book_new();
        const ws = utils.json_to_sheet(exportArr);
        utils.book_append_sheet(wb, ws, "Job Report");
        writeFile(wb, `JobReport.xlsx`, { bookType: "xlsx", type: "file" });
      }
    } catch (error) {
      console.error("Error exporting:", error);
      NotificationManager.error("Failed to export", "Error", 10000);
    } finally {
      setIsExporting(false);
    }
  }, [
    totalResult,
    userRecruitmentpartnerId,
    startSelectedDate,
    endSelectedDate,
    userIdType,
    userType,
    additionalFilterData,
    formatDateOnly
  ]);

  useEffect(() => {
    if (triggerAction) {
      callApiToGenerateExcel(); // Perform the action
      resetTrigger(); // Reset the trigger to avoid repeated execution
    }
  }, [triggerAction, resetTrigger, callApiToGenerateExcel]);



  // Search function without debounce
  const performSearch = useCallback(async (
    userRecruitmentpartnerId,
    pageNumber,
    takeNumberOfResult,
    startSelectedDate,
    endSelectedDate,
    userId,
    additionalFilterData
  ) => {
    let payload = {
      userRecruitmentpartnerId: userRecruitmentpartnerId,
      page: pageNumber,
      size: takeNumberOfResult,
      formattedDatestart: formatDateOnly(startSelectedDate),
      formattedDateend: formatDateOnly(endSelectedDate),
      isExport: false,
      userId: userId,
      role: userType,
      additionalFilter: {
        placementType: additionalFilterData.placementType,
        clientName: additionalFilterData.clientName,
        clientJobId: additionalFilterData.clientJobId || "",
        divisionId: additionalFilterData.divisionId,
        requisitionStatus: additionalFilterData.requisitionStatus,
        requisionSubStatus: additionalFilterData.requisionSubStatus,
        teamId: additionalFilterData.teamId || []
      }
    };


    const search = await jobReports(payload);

    if (search?.data?.length <= 0) {
      setDataResult([]);
      setTotalResult(0);
      setIsSearching(false);
    }
    if (search?.data?.length > 0) {
      setDataResult(search.data);
      if (search.totalCount[0].total)
        setTotalResult(search.totalCount[0].total);
      setIsSearching(false);
    }
  }, [formatDateOnly, userType]);

  // Debounce logic using setTimeout inside an effect (no ref / memo / external debounce)
  // Every change resets the timer; only the latest triggers performSearch after delay.
  const DEBOUNCE_DELAY = 1000; // ms

  // Handle page change
  const handlePageChange = (newPage, newPageSize) => {
    setPageNumber(newPage);
    if (newPageSize && newPageSize !== takeNumberOfResult) {
      setTakeNumberOfResult(newPageSize);
    }
  };

  // Handle page size change
  const handlePageSizeChange = (newPageSize) => {
    setTakeNumberOfResult(newPageSize);
    setPageNumber(1);
  };



  useEffect(() => {
    const datesChanged =
      prevStartDate !== startSelectedDate ||
      prevEndDate !== endSelectedDate;

    const filtersChanged =
      JSON.stringify(prevFilterData) !== JSON.stringify(additionalFilterData);

    if (datesChanged || filtersChanged) {
      setPageNumber(1);
      setPrevStartDate(startSelectedDate);
      setPrevEndDate(endSelectedDate);
      setPrevFilterData({ ...additionalFilterData });
    }
  }, [startSelectedDate, endSelectedDate, additionalFilterData]);


  useEffect(() => {
    if (!startSelectedDate || !endSelectedDate) {
      NotificationManager.error("Please enter a valid date", "Error", 10000);
      return;
    }

    // When any dependency changes, schedule a search.
    setIsSearching(true);
    setDataResult([]);

    const timeoutId = setTimeout(() => {
      performSearch(
        userRecruitmentpartnerId,
        pageNumber,
        takeNumberOfResult,
        startSelectedDate,
        endSelectedDate,
        userIdType,
        additionalFilterData
      );
    }, DEBOUNCE_DELAY);

    // Cleanup cancels the pending search if dependencies change quickly.
    return () => clearTimeout(timeoutId);
  }, [
    pageNumber,
    takeNumberOfResult,
    startSelectedDate,
    endSelectedDate,
    additionalFilterData,
    userRecruitmentpartnerId,
    userIdType,
    performSearch
  ]);

  return (
    <>
      <Backdrop sx={stylesSX.backdrop} open={isExporting}>
        <CircularProgress color="inherit" />
        <Typography sx={stylesSX.waitingText}>
          Please wait ...
        </Typography>
      </Backdrop>

      <DataTable
        data={dataResult}
        columns={columns}
        isLoading={isSearching}
        totalRecords={totalResult}
        currentPage={pageNumber}
        pageSize={takeNumberOfResult}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}

        enableFiltering={false}
        enablePagination={true}
        enableSorting={false}
        pageSizeOptions={[10, 20, 50, 100]}
        isServerSide={true}
        className="kendo_reports"
        noDataText="No results found !"
      />
    </>
  );
};

export default JobReport;
